const zxcvbn = require('zxcvbn');
const Lang = require('lang');
getAndSetLanguageFromCookie();

const bar0 =
  '<div class="progress" style="margin-bottom: 5px;">' +
    '<div class="progress-bar" role="progressbar" style="width: 10%; background-color: #FF0000" aria-valuenow="10" aria-valuemin="0" aria-valuemax="100"></div>' +
  '</div>';
const bar1 =
  '<div class="progress" style="margin-bottom: 5px;">' +
    '<div class="progress-bar bg-warning" role="progressbar" style="width: 25%; background-color: #f7841e" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>' +
  '</div>'
const bar2 =
  '<div class="progress" style="margin-bottom: 5px;">' +
    '<div class="progress-bar bg-info" role="progressbar" style="width: 50%; background-color: #adcfa1" aria-valuenow="50" aria-valuemin="0" aria-valuemax="100"></div>' +
  '</div>'
const bar3 =
  '<div class="progress" style="margin-bottom: 5px;">' +
    '<div class="progress-bar" role="progressbar" style="width: 75%; background-color: #82cb68" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100"></div>' +
  '</div>'
const bar4 =
  '<div class="progress" style="margin-bottom: 5px;">' +
    '<div class="progress-bar bg-success" role="progressbar" style="width: 100%; background-color: #3adf00" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>' +
  '</div>'
const attentionSpan = '<span id="attention-span" style="color: #FF0000"> ' +
                      Lang.get('js/src/functions/StrongPassword.attention') +
                    ': </span>'

function getAndSetLanguageFromCookie() {
  const match = document.cookie.match(RegExp('(?:^|;\\s*)language=([^;]*)'));
  if (match && match.length > 0) {
    Lang.locale = match[1];
    return match[1];
  }
  return 'pt-BR';
}

function validatePassword() {
  $('#password').on('keyup', function (event) {
    const btnSubmitTeamMember = $(this).closest('form').find('[data-submit-password-form]');
    const btnSubmitOnboarding = $('[data-onboarding-form="primeiraEtapa"]');
    const tip = $('#div-password-tip > div');
    const userNameInput = $(this).closest('form').find('[name="usuario[nome]"]')
    const userData = [];

    if (userNameInput.length) {
      userData.push(userNameInput.val());
    }

    let html = bar0;
    if ($(this).val()) {
      switch (zxcvbn($(this).val(), userData).score) {
        case 0:
          html = bar0;
          btnSubmitTeamMember.attr('disabled', true);
          btnSubmitOnboarding.attr('disabled', true).removeClass('btn-onboarding--primary');
          tip.html(attentionSpan + Lang.get('js/src/functions/StrongPassword.very_weak_password'));
          break;
        case 1:
          html = bar1;
          btnSubmitTeamMember.attr('disabled', true);
          btnSubmitOnboarding.attr('disabled', true).removeClass('btn-onboarding--primary');
          tip.html(attentionSpan + Lang.get('js/src/functions/StrongPassword.weak_password'));
          break;
        case 2:
          html = bar2;
          btnSubmitTeamMember.attr('disabled', false);
          btnSubmitOnboarding.attr('disabled', false).addClass('btn-onboarding--primary');
          tip.html(Lang.get('js/src/functions/StrongPassword.medium_password'));
          break;
        case 3:
          html = bar3;
          btnSubmitTeamMember.attr('disabled', false);
          btnSubmitOnboarding.attr('disabled', false).addClass('btn-onboarding--primary');
          tip.html(Lang.get('js/src/functions/StrongPassword.strong_password'));
          break;
        case 4:
          html = bar4;
          btnSubmitTeamMember.attr('disabled', false);
          btnSubmitOnboarding.attr('disabled', false).addClass('btn-onboarding--primary');
          tip.html(Lang.get('js/src/functions/StrongPassword.very_strong_password'));
          break;
        default:
          html = bar0;
          tip.html(Lang.get('js/src/functions/StrongPassword.very_weak_password'));
      }
    } else {
      html = bar0;
      btnSubmitTeamMember.attr('disabled', false);
      btnSubmitOnboarding.attr('disabled', false).addClass('btn-onboarding--primary');
      tip.html(attentionSpan + Lang.get('js/src/functions/StrongPassword.very_weak_password'));
    }

    $('#div-password-progress-bar').html(html);
  });
}

exports.init = validatePassword;
